export default __webpack_public_path__ + "static/media/Terms.71297879.svg";